import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Zap, FileText, Sparkles, Calendar, Video, Copy, BarChart3 } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuShortcut,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';
import { Button } from './ui/button';

export default function QuickActions({ doctorId }) {
  const navigate = useNavigate();

  const actions = [
    {
      label: 'Generate Ideas',
      icon: Sparkles,
      action: () => navigate(`/ideas/${doctorId}`),
      shortcut: '⌘I',
      category: 'create'
    },
    {
      label: 'Create Script',
      icon: FileText,
      action: () => navigate(`/script/${doctorId}`),
      shortcut: '⌘S',
      category: 'create'
    },
    {
      label: 'Batch Generate',
      icon: Zap,
      action: () => navigate(`/batch/${doctorId}`),
      shortcut: '⌘B',
      category: 'create'
    },
    {
      label: 'View Calendar',
      icon: Calendar,
      action: () => navigate(`/calendar/${doctorId}`),
      shortcut: '⌘C',
      category: 'manage'
    },
    {
      label: 'Content Library',
      icon: Copy,
      action: () => navigate(`/library/${doctorId}`),
      shortcut: '⌘L',
      category: 'manage'
    },
    {
      label: 'Create Video',
      icon: Video,
      action: () => navigate(`/video/${doctorId}`),
      shortcut: '⌘V',
      category: 'create'
    },
    {
      label: 'View Analytics',
      icon: BarChart3,
      action: () => navigate(`/analytics/${doctorId}`),
      shortcut: '⌘A',
      category: 'manage'
    }
  ];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          className="button-pill bg-[#D98A6C] hover:bg-[#c77958] text-white rounded-full"
          data-testid="quick-actions-btn"
        >
          <Zap className="w-4 h-4 mr-2" strokeWidth={1.5} />
          Quick Actions
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56 bg-white rounded-2xl border border-[#2C5F44]/10">
        <DropdownMenuLabel className="text-[#1C2A21]">Quick Actions</DropdownMenuLabel>
        <DropdownMenuSeparator />
        
        {actions.filter(a => a.category === 'create').map((action) => (
          <DropdownMenuItem
            key={action.label}
            onClick={action.action}
            className="cursor-pointer hover:bg-[#F4F1EA] rounded-lg"
            data-testid={`quick-action-${action.label.toLowerCase().replace(' ', '-')}`}
          >
            <action.icon className="w-4 h-4 mr-2 text-[#2C5F44]" strokeWidth={1.5} />
            <span className="text-[#1C2A21]">{action.label}</span>
            <DropdownMenuShortcut className="text-[#5C7063]">
              {action.shortcut}
            </DropdownMenuShortcut>
          </DropdownMenuItem>
        ))}
        
        <DropdownMenuSeparator />
        
        {actions.filter(a => a.category === 'manage').map((action) => (
          <DropdownMenuItem
            key={action.label}
            onClick={action.action}
            className="cursor-pointer hover:bg-[#F4F1EA] rounded-lg"
            data-testid={`quick-action-${action.label.toLowerCase().replace(' ', '-')}`}
          >
            <action.icon className="w-4 h-4 mr-2 text-[#2C5F44]" strokeWidth={1.5} />
            <span className="text-[#1C2A21]">{action.label}</span>
            <DropdownMenuShortcut className="text-[#5C7063]">
              {action.shortcut}
            </DropdownMenuShortcut>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
